import Portfolio from "../../componets/Portfolio";

export default function Section1() {
  return (
    <div className="Section1 h-[30vh] xl:h-[60vh]">
      <Portfolio
        bgImage={"assets/web-banner-clients-testimonial-1-1.jpg"}
        mobileBgImage={"assets/mob-banner-client-testimonial-1-1.jpg"}
        objectPosition={"object-center"}
        customer={false}
        altText="Social Media Marketing Background Image"
      />
    </div>
  );
}
